import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@mui/material';

import ManageButton from '@/views/components/ManageButton/ManageButton';

const DictionaryItemMenu = ({
	onEditItem,
	onDeleteItem,
	data,
}) => {
	const { dict } = useSelector((state) => state.app);
	const [ open, setOpen ] = useState(false);
	const anchorRef = useRef(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (
			anchorRef.current &&
            anchorRef.current.contains(event.target)
		) {
			return;
		}
		setOpen(false);
	};

	const handleEdit = (ev) => {
		onEditItem(data);
		handleClose(ev);
	};

	const handleDelete = (ev) => {
		onDeleteItem(data);
		handleClose(ev);
	};

	const handleListKeyDown = (event) => {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		} else if (event.key === 'Escape') {
			setOpen(false);
		}
	};

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = useRef(open);
	useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}
		prevOpen.current = open;
	}, [ open ]);

	return (
		<>
			<ManageButton 
				forwardRef={ anchorRef } 
				open={ open }
				handleToggle={ handleToggle }
			/>
			<Popper
				open={ open }
				anchorEl={ anchorRef.current }
				role={ undefined }
				placement='bottom-start'
				transition
				disablePortal
				className='mui__popper'
			>

				{({ TransitionProps, placement }) => (
					<Grow
						{ ...TransitionProps }
						style={ {
							transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
						} }
					>
						<Paper>
							<ClickAwayListener onClickAway={ handleClose }>
								<MenuList
									autoFocusItem={ open }
									id='composition-menu'
									aria-labelledby='composition-button'
									onKeyDown={ handleListKeyDown }
								>

									{ data.rights.canEdit && (
										<MenuItem
											className='table__menu-item'
											onClick={ handleEdit }
										>
											{dict.dictionary.list[`edit`]}
										</MenuItem>
									)}
									{ data.rights.canDelete &&  (
										<MenuItem
											className='table__menu-item'
											onClick={ handleDelete }
										>
											{dict.dictionary.list.delete}
										</MenuItem>
									)}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};

export default React.memo(DictionaryItemMenu);